const httpHost = process.env.REACT_APP_API_KEY;

export const getAllDropdownValues = `${httpHost}/api/LookUps/All`;
export const postApplicantDetails = `${httpHost}/api/Applicant`;
